export default "/images/vendor/@coreui/icons/svg/flag/cif-gt.svg?be30fd90b7fc9a01c9438e9396e7631e";